import { isCondensedCheckoutExcluded } from '../components/EventDetails/ConversionBarContainer/isCondensedCheckoutExcluded';
import { useEventBasicInformationContext, useTicketContext } from '../contexts';

export const useCondensedCheckoutExperiment = () => {
    const {
        ticketData: { compactCheckoutDisqualifications },
    } = useTicketContext();
    const { salesStatus } = useEventBasicInformationContext();

    const isTicketSelectionExcluded = isCondensedCheckoutExcluded({
        soldOut: compactCheckoutDisqualifications.sold_out,
        isSalesEnded: compactCheckoutDisqualifications.is_sales_ended,
        isPostponed: compactCheckoutDisqualifications.is_postponed,
        isCanceled: compactCheckoutDisqualifications.is_canceled,
        hasWaitlist: compactCheckoutDisqualifications.has_waitlist,
        isRsvp: compactCheckoutDisqualifications.is_rsvp,
        salesStatus,
    });
    return !isTicketSelectionExcluded;
};
